import Questionnaire from './Questionnaire'

export {
  Questionnaire
}


// WEBPACK FOOTER //
// ./src/screens/Questionnaire/index.js